import { Search32 } from "@carbon/icons-react";
import { Add16, Edit24, Edit32, TrashCan24 } from "@carbon/icons-react";
import { Form } from "carbon-components-react";
import { Column } from "carbon-components-react";
import { TextInput } from "carbon-components-react";
import { Row } from "carbon-components-react";
import {
  Button,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
} from "carbon-components-react";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import GenericCombo from "../../components/Combos/GenericCombo";
import TablePagination from "../../components/Pagination/Pagination";
import useGet from "../../hooks/useGet";
import http from "../../http-common";

const tableHeaders = [
  {
    header: "Nome",
    key: "firstName",
  },
  {
    header: "Apelido",
    key: "lastName",
  },
  {
    header: "Telefone",
    key: "username",
  },
  {
    header: "Email",
    key: "email",
  },
  {
    header: "Perfil",
    key: "role",
  },
  {
    header: "Activo",
    key: "enabled",
  },
  {
    header: "Operações",
    key: "actions",
  },
];

const LinkList = ({ url, url2 }) => (
  <ul style={{ display: "flex" }}>
    <li>
      <Link to={url} title="Editar">
        <Edit24 />
      </Link>
    </li>
    &nbsp;&nbsp;&nbsp;
    <li>
      <Link to={url2} title="Inactivar" className="emprega-orange">
        <TrashCan24 />
      </Link>
    </li>
  </ul>
);

const UsersPage = () => {
  // const { data: users } = useGet("/users");
  const [user, setUser] = useState([]);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(20);

  const { data: roles } = useGet("/lookup/user-roles");

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const featchData = async () => {
    try {
      const response = await http.get("/users/search/q?size=" + size);

      getUserData(response);
    } catch (error) {}
  };

  const onPageChange = async ({ page, pageSize }) => {
    try {
      var pag = page - 1;
      const response = await http.get(
        "/users/search/q?page=" + pag + "&size=" + pageSize
      );
      getUserData(response);
    } catch (error) {}
  };

  const onSearch = async (data) => {
    try {
      const response = await http.get(
        `/users/search/q?username=${data.username}&firstName=${data.firstName}&lastName=${data.lastName}&roleCode=${data.roleCode}`
      );
      getUserData(response);
    } catch (error) {}
  };

  const getUserData = (response) => {
    const data = response.data.content.map((user) => ({
      id: user.username,
      firstName: user.firstName,
      lastName: user.lastName,
      username: user.username,
      email: user.email,
      role: user.role.description,
      enabled: user.enabled ? "Sim" : "Não",
      actions: (
        <LinkList
          url={"../actualizar-utilizador/" + user.username}
          url2={"inactivar-utilizador/" + user.username}
        />
      ),
    }));
    setUser(data);
    setCount(response.data.totalElements);
  };

  useEffect(() => {
    featchData();
  }, []);

  return (
    <Card title="Utilizadores">
      <div className="mb-2 form-buttons">
        <p></p>
        <Button
          kind="ghost"
          onClick={() => navigate("../registar-utilizador")}
          renderIcon={Add16}
        >
          Registar Utilizador
        </Button>
      </div>
      <DataTable rows={user} headers={tableHeaders} isSortable useZebraStyles>
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <TableToolbar aria-label="data table toolbar">
              <TableToolbarContent>
                {/* <TableToolbarSearch
                  placeholder="Digite o número de telefone para pesquisar"
                  onChange={(e) => search(e.target.value)}
                /> */}
                <Form
                  className="data-table-search-form"
                  onSubmit={handleSubmit(onSearch)}
                >
                  <Row>
                    <Column sm={6} md={3} lg={3}>
                      <TextInput
                        id="firstName"
                        labelText=""
                        placeholder="Nome"
                        {...register("firstName")}
                      />
                    </Column>
                    <Column sm={6} md={3} lg={3}>
                      <TextInput
                        id="lastName"
                        labelText=""
                        placeholder="Apelido"
                        {...register("lastName")}
                      />
                    </Column>
                    <Column sm={6} md={2} lg={2}>
                      <TextInput
                        id="username"
                        labelText=""
                        placeholder="Telefone"
                        {...register("username")}
                      />
                    </Column>
                    <Column sm={12} md={3} lg={3}>
                      <GenericCombo
                        id="roleCode"
                        name="roleCode"
                        label=""
                        register={register}
                        items={roles}
                      />
                    </Column>
                  </Row>
                  <Button type="submit" renderIcon={Search32}>
                    Pesquisar
                  </Button>
                </Form>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>{cell.value}</TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
      <TablePagination
        currentPageSize={size}
        onPageChange={onPageChange}
        totalItems={count}
      />
    </Card>
  );
};

export default UsersPage;
